import { createFeature, createReducer, on } from '@ngrx/store';
import { UsageSnapshotActions } from './usage-snapshot.actions';
import { UsageSnapshot } from './models/usage-snapshot.model';

interface State {
  snapshot: UsageSnapshot;
  error: any;
}

const initialState: State = {
  snapshot: null,
  error: null,
};

export const usageSnapshotFeature = createFeature({
  name: 'usageSnapshot',
  reducer: createReducer(
    initialState,
    on(UsageSnapshotActions.getUsageSnapshotSucceeded, (state, { snapshot }) => ({
      ...state,
      snapshot,
    })),
    on(UsageSnapshotActions.getUsageSnapshotErrored, (state, { error }) => ({
      ...state,
      error,
    })),
  ),
});
